class SaveBookingLocationDto {
  id?: string;
  location!: string;
  displayOrder!: string;
}

export default SaveBookingLocationDto;
